var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-modal",
    {
      attrs: { "aria-label": _vm.popupConfig.header, role: "dialog" },
      on: { hide: _vm.close },
      model: {
        value: _vm.opened,
        callback: function ($$v) {
          _vm.opened = $$v
        },
        expression: "opened",
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "header" }, slot: "header" },
        [
          _c("basic-modal-close-button", { ref: "closeButton" }),
          _vm._v(" "),
          _c("h3", { staticClass: "modal-title" }, [
            _vm._v(_vm._s(_vm.popupConfig.header)),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-12" }, [
            _vm._v("\n                Section name:\n                "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.sectionData.caption,
                  expression: "sectionData.caption",
                },
              ],
              ref: "sectionName",
              staticClass: "form-control",
              attrs: {
                type: "text",
                placeholder: "Give this section a name",
                disabled: !_vm.popupConfig.allow_change_name,
                minlength: "2",
                maxlength: "55",
              },
              domProps: { value: _vm.sectionData.caption },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.sectionData, "caption", $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _vm.popupConfig.additional_info ? _c("br") : _vm._e(),
            _vm._v(" "),
            _c("i", [_vm._v(_vm._s(_vm.popupConfig.additional_info))]),
            _vm._v(" "),
            _c("hr"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          !_vm.sectionData.avatar
            ? _c(
                "div",
                { staticClass: "col-sm-4" },
                [
                  _c(
                    "btn",
                    {
                      staticClass: "btn btn-mm text-left",
                      staticStyle: {
                        width: "173px",
                        padding: "7px 15px 13px 0",
                      },
                      on: { click: _vm.addAvatar },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "vertical-middle",
                          staticStyle: {
                            "text-align": "center",
                            display: "inline-block",
                          },
                        },
                        [_c("i", { staticClass: "fa fa-image fa-2" })]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "vertical-middle" }, [
                        _vm._v(" + Add Picture"),
                      ]),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.sectionData.avatar
            ? _c("div", { staticClass: "col-sm-8" }, [
                _vm._v(
                  "\n                Multi Me will automatically select a picture if you do not add one here.\n            "
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.sectionData.avatar
            ? _c(
                "div",
                { staticClass: "col-sm-4" },
                [
                  _c("media-preview", {
                    attrs: { item: _vm.sectionData.avatar, "allow-delete": "" },
                    on: { onDelete: _vm.resetAvatar },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.sectionData.avatar
            ? _c("div", { staticClass: "col-sm-4" }, [
                _vm._v(
                  "\n                Avatar: " +
                    _vm._s(_vm.sectionData.avatar.name) +
                    "\n            "
                ),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        !_vm.sectionData.audio_caption
          ? _c("div", { staticClass: "row margin-15-top" }, [
              _c(
                "div",
                { staticClass: "col-sm-4" },
                [
                  _c(
                    "btn",
                    {
                      staticClass: "btn btn-mm text-left",
                      staticStyle: {
                        width: "173px",
                        "text-align": "left",
                        padding: "7px 15px 13px 0",
                      },
                      on: { click: _vm.addAudio },
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "vertical-middle",
                          staticStyle: {
                            width: "37px",
                            "margin-left": "4px",
                            "text-align": "center",
                            display: "inline-block",
                          },
                        },
                        [
                          _c("i", {
                            staticClass:
                              "fa fa-microphone fa-2 vertical-middle",
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("span", { staticClass: "vertical-middle" }, [
                        _vm._v(" + Add Audio"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.sectionData.audio_caption
                ? _c("div", { staticClass: "col-sm-8" }, [
                    _vm._v(
                      "\n                Add an audio caption so users can listen to the name.\n            "
                    ),
                  ])
                : _vm._e(),
            ])
          : _c("div", { staticClass: "row margin-15-top" }, [
              _c(
                "div",
                { staticClass: "col-sm-4" },
                [
                  _c("media-preview", {
                    attrs: {
                      item: _vm.sectionData.audio_caption,
                      "allow-delete": "",
                    },
                    on: { onDelete: _vm.resetAudio },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _vm._v(
                  "\n                Audio caption: " +
                    _vm._s(_vm.sectionData.audio_caption.name) +
                    "\n            "
                ),
              ]),
            ]),
        _vm._v(" "),
        _vm.popupConfig.allow_create_subsections
          ? _c("div", { staticClass: "row margin-15-top" }, [
              _c(
                "div",
                { staticClass: "col-sm-4" },
                [
                  _c("vue-switch-with-label", {
                    attrs: { label: "", name: "ms" },
                    model: {
                      value: _vm.sectionData.is_submenu,
                      callback: function ($$v) {
                        _vm.$set(_vm.sectionData, "is_submenu", $$v)
                      },
                      expression: "sectionData.is_submenu",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-8" }, [
                _vm._v(
                  "\n                Create multiple sections inside this section\n            "
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row", attrs: { slot: "footer" }, slot: "footer" },
        [
          _c("div", { staticClass: "col-xs-4 text-left" }, [
            _vm.popupConfig.allow_delete
              ? _c(
                  "button",
                  { staticClass: "btn btn-mm btn-red", on: { click: _vm.del } },
                  [_vm._v("Delete")]
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-8 text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-mm btn-green",
                attrs: { disabled: !_vm.sectionData.caption },
                on: { click: _vm.create },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.popupConfig.save_button) +
                    "\n            "
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }